export type ProductUnit = "g" | "ml" | "piece";

export type Product = {
  id: string;
  name: string;
  brand: string | null;
  kcal_100g: string;
  protein_100g: string;
  fat_100g: string;
  saturated_fat_100g: string | null;
  carbs_100g: string;
  sugar_100g: string | null;
  fiber_100g: string | null;
  unit: ProductUnit;
  vv_price: string | null;
  barcode: string | null;
  analogs: string[];
  created_at: string;
  updated_at: string;
};

export type ProductInput = {
  name: string;
  brand?: string | null;
  kcal_100g: number;
  protein_100g: number;
  fat_100g: number;
  saturated_fat_100g?: number | null;
  carbs_100g: number;
  sugar_100g?: number | null;
  fiber_100g?: number | null;
  unit: ProductUnit;
  vv_price?: number | null;
  barcode?: string | null;
  analogs?: string[];
};

const BASE = "/api/products";

async function jsonOrThrow<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw new Error(`HTTP ${res.status}: ${text}`);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

export async function listProducts(q?: string, limit = 50, offset = 0): Promise<Product[]> {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  params.set("limit", String(limit));
  params.set("offset", String(offset));
  const res = await fetch(`${BASE}?${params.toString()}`);
  return jsonOrThrow<Product[]>(res);
}

export async function createProduct(p: ProductInput): Promise<Product> {
  const res = await fetch(BASE, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(p),
  });
  return jsonOrThrow<Product>(res);
}

export async function updateProduct(id: string, p: Partial<ProductInput>): Promise<Product> {
  const res = await fetch(`${BASE}/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(p),
  });
  return jsonOrThrow<Product>(res);
}

export async function deleteProduct(id: string): Promise<void> {
  const res = await fetch(`${BASE}/${id}`, { method: "DELETE" });
  await jsonOrThrow<void>(res);
}
